import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { HomeEditionService, UpdateAppNewsParams } from 'src/Services/API';

import { MutationKeys, QueryKeys } from '../types';

export const useUpdateAppNews = () => {
  const queryClient = useQueryClient();

  return useMutation(
    [MutationKeys.updateAppNews],
    async (params: UpdateAppNewsParams) => {
      return await HomeEditionService.homeEditionControllerUpdateAppNews({ body: params });
    },
    {
      onSuccess: () => {
        toast.success('la nouveauté a été modifiée');
        queryClient.invalidateQueries([QueryKeys.fetchAppNews]);
        queryClient.invalidateQueries([QueryKeys.fetchAllAppNews]);
      },
      onError: (error: AxiosError) => {
        queryClient.invalidateQueries([QueryKeys.fetchAppNews]);
        queryClient.invalidateQueries([QueryKeys.fetchAllAppNews]);
        switch (error.response?.status) {
          case 403:
            toast.error('droits insuffisants pour modifier la nouveauté');
            break;
          default:
            toast.error('erreur lors de la modification de la nouveauté');
            break;
        }
      },
    }
  );
};
